"use strict";
/* !
 * (c) Copyright 2025 Palantir Technologies Inc. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonVariant = void 0;
/** The visual style variant for buttons. */
exports.ButtonVariant = {
    MINIMAL: "minimal",
    OUTLINED: "outlined",
    SOLID: "solid",
};
//# sourceMappingURL=buttonVariant.js.map